export const Types = {
  SAVE_LIST_VOUCHER: 'SAVE_LIST_VOUCHER'
}
